// «No business at all» (erp-core ResolveActive / bff-business rbac.Resolve:
// 400 business_required = the signed-in person has ZERO memberships — their
// only business was deleted, or they were removed from it). Any authed call
// that gets it reports here; the app's NoBusinessGate (inside RequireAuth)
// drops the stale business/branch and opens the onboarding's «create your
// business» step instead of a dead-end error card. A transient 503
// membership_unavailable is NOT this (it keeps the retry).
//
// Reports are a sequence number, not a flag: the gate only acts on reports
// made after it mounted, so a business_required seen elsewhere (e.g. on the
// public onboarding screens) can never bounce a later visit to «اليوم».

export const BUSINESS_REQUIRED = 'business_required';

type Listener = () => void;
const listeners = new Set<Listener>();
let seq = 0;

export const noBusinessStore = {
  seq: (): number => seq,
  report(): void {
    seq += 1;
    listeners.forEach((l) => l());
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
